import { render, staticRenderFns } from "./DisbursementListPopover.vue?vue&type=template&id=6c1f6949"
import script from "./DisbursementListPopover.vue?vue&type=script&lang=js"
export * from "./DisbursementListPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports